var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentHubIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#E71316"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9071 24.2559C17.3181 24.2045 17.6929 24.496 17.7443 24.9071L18.2443 28.9071C18.2957 29.3181 18.0041 29.6929 17.5931 29.7443C17.1821 29.7957 16.8072 29.5041 16.7559 29.0931L16.2559 25.0931C16.2045 24.6821 16.496 24.3072 16.9071 24.2559Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29V13H19.5L20 17L20.5 21L21 25L17.5 29H29Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9378 12.5036C19.0801 12.3424 19.2849 12.25 19.5 12.25H29C29.4142 12.25 29.75 12.5858 29.75 13V29C29.75 29.4142 29.4142 29.75 29 29.75H17.5C17.2057 29.75 16.9386 29.5779 16.817 29.3099C16.6954 29.0419 16.7418 28.7276 16.9356 28.5061L20.2141 24.7593L18.7558 13.093C18.7291 12.8796 18.7954 12.6649 18.9378 12.5036ZM20.3496 13.75L21.7442 24.907C21.7708 25.1193 21.7053 25.3328 21.5644 25.4939L19.1528 28.25H28.25V13.75H20.3496Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 21C19.75 20.5858 20.0858 20.25 20.5 20.25H24.5C24.9142 20.25 25.25 20.5858 25.25 21C25.25 21.4142 24.9142 21.75 24.5 21.75H20.5C20.0858 21.75 19.75 21.4142 19.75 21Z",
    fill: "#E71316"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 17C19.25 16.5858 19.5858 16.25 20 16.25H24.5C24.9142 16.25 25.25 16.5858 25.25 17C25.25 17.4142 24.9142 17.75 24.5 17.75H20C19.5858 17.75 19.25 17.4142 19.25 17Z",
    fill: "#E71316"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H19L19.5 13L20 17L20.5 21L21 25H17H9V9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 9C8.25 8.58579 8.58579 8.25 9 8.25H19C19.3782 8.25 19.6973 8.53165 19.7442 8.90697L21.7442 24.907C21.7709 25.1204 21.7046 25.3351 21.5623 25.4964C21.4199 25.6576 21.2151 25.75 21 25.75H9C8.58579 25.75 8.25 25.4142 8.25 25V9ZM9.75 9.75V24.25H20.1504L18.3379 9.75H9.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 13C11.25 12.5858 11.5858 12.25 12 12.25H15.5C15.9142 12.25 16.25 12.5858 16.25 13C16.25 13.4142 15.9142 13.75 15.5 13.75H12C11.5858 13.75 11.25 13.4142 11.25 13Z",
    fill: "#E71316"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 17C11.25 16.5858 11.5858 16.25 12 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H12C11.5858 17.75 11.25 17.4142 11.25 17Z",
    fill: "#E71316"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 21C11.25 20.5858 11.5858 20.25 12 20.25H16.5C16.9142 20.25 17.25 20.5858 17.25 21C17.25 21.4142 16.9142 21.75 16.5 21.75H12C11.5858 21.75 11.25 21.4142 11.25 21Z",
    fill: "#E71316"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentHubIcon);
export default __webpack_public_path__ + "static/media/contentHubIcon.bceed237daf042f87ab91c62ddf6226f.svg";
export { ForwardRef as ReactComponent };